// extracted by mini-css-extract-plugin
module.exports = {"tile":"ArticleTile_tile__wOt2K","tileContent":"ArticleTile_tileContent__huqLr"};